const sharepointConfig = {
  verlofTypes: [
    { key: 'vakantie', text: 'Vrij', label: 'V', color: '#0078D4', aftrekSaldo: 'verlof',
      beschrijving: 'Vakantie', aftrekInfo: '✂️ Met aftrek' },
    { key: 'verlof', text: 'Verlof', label: 'VL', color: '#E86E1C', aftrekSaldo: 'verlof',
      beschrijving: 'Snipperdag, vrije dag, overige', aftrekInfo: '✂️ Met aftrek' },
    { key: 'ziek', text: 'Ziek', label: 'Z', color: '#D13438', aftrekSaldo: 'geen',
      beschrijving: 'Ziekteverlof (via Ziekmelding menu)', aftrekInfo: '✅ Geen aftrek — loondoorbetaling' },
    { key: 'bijzonder', text: 'Bijzonder verlof', label: 'BV', color: '#8764B8', aftrekSaldo: 'geen',
      beschrijving: 'Overlijden, huwelijk, verhuizing, geboorte, jubileum',
      aftrekInfo: '✅ Geen aftrek — wettelijk recht (max. dagen per gebeurtenis)',
      wettelijkMaximum: [
        { gebeurtenis: 'Overlijden partner/kind/ouder', dagen: '4 dagen' },
        { gebeurtenis: 'Overlijden schoonouder/broer/zus', dagen: '2 dagen' },
        { gebeurtenis: 'Overlijden grootouder/kleinkind', dagen: '1 dag + dag bijwoning uitvaart' },
        { gebeurtenis: 'Huwelijk medewerker', dagen: '2 dagen' },
        { gebeurtenis: 'Huwelijk kind/broer/zus', dagen: '1 dag' },
        { gebeurtenis: 'Geboorte kind (partner)', dagen: '1 dag + geboorteverlof (5 dagen)' },
        { gebeurtenis: 'Verhuizing', dagen: '1-2 dagen' },
        { gebeurtenis: '25/40/50 jaar huwelijksjubileum', dagen: '1 dag' },
      ],
    },
    { key: 'kort-verzuim', text: 'Verlof medische', label: 'VM', color: '#107C10', aftrekSaldo: 'geen',
      beschrijving: 'Verlofwijzer verplicht',
      aftrekInfo: '✅ Geen aftrek — Verlofwijzer bepaalt type (WAZO Art. 4:1 / 5:1)',
      requiresWijzer: true },
    { key: 'onbetaald', text: 'Onbetaald verlof', label: 'OV', color: '#767676', aftrekSaldo: 'geen',
      beschrijving: 'Opmerking verplicht',
      aftrekInfo: '⚠️ Geen aftrek — geen loon uitbetaald',
      requiresReden: true },
    { key: 'flex', text: 'Flex (min)', label: 'F-', color: '#107C10', aftrekSaldo: 'flex',
      beschrijving: 'Flexuren opnemen (ADV)', aftrekInfo: '✂️ Trekt af van flex/ADV saldo' },
    { key: 'flex-plus', text: 'Flex (plus)', label: 'F+', color: '#00B7C3', aftrekSaldo: 'flex-plus',
      beschrijving: 'Extra flexuren werken', aftrekInfo: '➕ Voegt toe aan flex/ADV saldo' },
  ],
  statusOpties: [
    { key: 'ingediend', text: 'Ingediend', color: '#FFB900' },
    { key: 'goedgekeurd', text: 'Goedgekeurd', color: '#107C10' },
    { key: 'afgekeurd', text: 'Afgekeurd', color: '#D13438' },
    { key: 'ingetrokken', text: 'Ingetrokken', color: '#767676' },
    { key: 'uitbetaald', text: 'Uitbetaald', color: '#8764B8' },
  ],
  rollen: [
    { key: 'admin', text: 'Beheerder', icon: '👑', color: '#8764B8' },
    { key: 'manager', text: 'Manager', icon: '📋', color: '#0078D4' },
    { key: 'medewerker', text: 'Medewerker', icon: '👤', color: '#107C10' },
    { key: 'flexkracht', text: 'Flexkracht', icon: '⚡', color: '#E86E1C' },
  ],
  // Kleuren voor medewerkers in kalender (cyclisch toegewezen)
  medewerkerKleuren: [
    '#0078D4', '#107C10', '#8764B8', '#E86E1C', '#D13438',
    '#00B7C3', '#744DA9', '#498205', '#DA3B01', '#0063B1',
  ],
  standaardContractUren: 200,
  maxOverurenSaldo: 40,
  pauze: {
    start: '12:30',
    eind: '13:00',
    duurMinuten: 30,
    dagen: [1, 2, 3, 4, 5],
  },
  inAppNotificatie: true,
};

export default sharepointConfig;
